import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { SelectBox } from 'cbc-shared-lib';
import { Sgke352aResponseBaseList, Sgke352aResponseSearchresultHyojiInfo, Sgke352aResponseSearchresultList, Sgke352aResponseWorkTntshList } from 'sg-api';
import { ListSearchUtils } from '../../../../../sg-ke-shared/util/list-search-utils';

@Component({
  selector: 'app-sgke350d-result',
  templateUrl: './sgke350d-result.component.html',
  styleUrl: './sgke350d-result.component.scss'
})
export class Sgke350dResultComponent implements OnInit, OnDestroy, AfterViewInit {

  /** 検索結果リスト */
  @Input() searchresultList: Array<Sgke352aResponseSearchresultList>;
  /** 検索結果表示情報 */
  @Input() searchresultHyojiInfo: Sgke352aResponseSearchresultHyojiInfo;

  /** 登録ボタン押下イベント */
  @Output() onClickRegistEvent = new EventEmitter<Sgke352aResponseSearchresultList[]>();

  /** ソート */
  @ViewChild('sort1', { static: true }) sort: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;

  /** データソース */
  dataSource: MatTableDataSource<Sgke352aResponseSearchresultList>;
  /** 選択した行の情報 */
  selection = new SelectionModel<Sgke352aResponseSearchresultList>(true, []);

  // 作業担当者リスト（レスポンス値）
  workTntshList: Array<Sgke352aResponseWorkTntshList>;

  /** 再開種別リスト */
  resumeClsfyList: SelectBox[] = [];
  /** 拠点リスト */
  baseList:  Array<Sgke352aResponseBaseList>;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'resumeClsfy',
    'base',
    'workTntsh',
    'suppntSpno',
    'sougouHisougou.aname',
    'parentChild.aname',
    'supplydestinationAddr',
    'gastype.aname',
    'errorStr',
    'supplystopResumeSts.aname',
    'supplyresumptionPlndate',
    'forcedsuspensionTargetflag',
    'payCtrNo',
    'visitName',
  ];

  /**
   * すべての対象チェックボックスチェックフラグ取得
   * @return {boolean}
   * @memberof Sgke350dResultComponent
   */
  get isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /**
   * コンストラクタ
   * @param {ListSearchUtils} listSearchUtils
   * @memberof Sgke350dResultComponent
   */
  constructor(
    private listSearchUtils: ListSearchUtils,
  ) {
  }

  /**
   * 初期処理
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  ngOnInit(): void {

    // 作業担当者リストを取得
    this.workTntshList = this.searchresultHyojiInfo.workTntshList;
    // 拠点リストを取得
    this.baseList = this.searchresultHyojiInfo.baseList;

    // "SGKE352A検索結果"に再開種別に紐づく拠点リストとその拠点に紐づく作業担当者リストを追加
    let extendedSearchresultList = this.searchresultList.map(row => ({
      ...row,
      baseList: this.createBaseList(row.resumeClsfy.codeValue),
      tntshList: this.createTntshList(row.base.codeValue,row.resumeClsfy.codeValue)
    }))

    // 再開種別リスト設定
    this.resumeClsfyList = this.getSelector(this.searchresultHyojiInfo.resumeClsfyList);

    // 再開種別リスト、拠点リスト、作業担当者リストの初期表示値に異常値が入らないようガード
    extendedSearchresultList.forEach(row => (
      row.resumeClsfy.codeValue = this.listSearchUtils.getListboxValue(row.resumeClsfy.codeValue, this.resumeClsfyList) ?? null,
      row.base.codeValue = this.listSearchUtils.getListboxValue(row.base.codeValue, row.baseList),
      row.workTntsh.codeValue = this.listSearchUtils.getListboxValue(row.workTntsh.codeValue, row.tntshList)
    ))

    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke352aResponseSearchresultList>(extendedSearchresultList);

    this.dataSource.sortingDataAccessor = (item, property) => {
      if (property === 'supplyresumptionPlndate') {
        return item?.supplyresumptionPlndate + item?.supplyresumptionYoteijikokuCode.aname;
      } else {
        return property
          .split('.')
          .reduce((acc, key) => acc?.[key], item);
      }
    };

  }

  /**
   * 画面描画後
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  ngAfterViewInit(): void {
    // 表データとソートを連携
    this.dataSource.paginator ??= this.paginator;
    this.dataSource.sort ??= this.sort;
  }

  /**
   * 購読解除
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * ヘッダ対象チェックボックス押下処理
   * 対象チェックボックスすべてにチェックされていない場合
   * @public
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  public onClickAllCheck(): void {
    this.dataSource.data.forEach(row => {
      this.selection.select(row);
    });
  }

  /**
   * ヘッダ対象チェックボックス押下処理
   * 1つでも対象チェックボックスにチェックされている場合
   * @public
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  public onClickAllClear(): void {
    this.selection.clear();
  }

  /**
   * 登録ボタン活性チェック
   * @public
   * @returns {boolean}
   * @memberof Sgke350dResultComponent
   */
  public checkRegistButtonEnable(): boolean {
    return this.selection.selected.length > 0;
  }


  /**
   * 登録ボタン押下時処理
   * @public
   * @returns {void}
   * @memberof Sgke350dResultComponent
   */
  public onClickRegist(): void {
    this.onClickRegistEvent.emit(this.selection.selected);
  }

  /**
   * 拠点変更時処理
   * @public
   * @param {string} baseCode 
   * @param {any} row 
   * @returns {void}
   * @memberof Sgke350dResultComponent
   */
  public onChangeBase(baseCode: string, row: any): void {
    // 作業担当者リスト更新
    row.tntshList = this.createTntshList(baseCode,row.resumeClsfy.codeValue);
  }

  /**
   * 再開種別ドロップダウン変化時処理
   * @public
   * @param {string} resumeClscode 
   * @param {any} row 
   * @return {void}
   * @memberof Sgke350dResultComponent
   */
  public onChangeResumeClsfy(resumeClscode:string,row: any): void {
    // 拠点を未選択状態に設定
    row.base.codeValue = null;
     // 拠点リスト更新
    row.baseList = this.createBaseList(resumeClscode);
    // 作業担当者を未選択状態に設定
    row.workTntsh.codeValue =  null;
    // 作業担当者リスト更新
    row.tntshList = this.createTntshList(null,null);
  }

  /**
   * 再開種別に紐づく拠点リスト作成
   * @private
   * @param {string} resumeClscode
   * @return {SelectBox[]}
   * @memberof Sgke350dResultComponent
   */
  private createBaseList(resumeClscode:string):SelectBox[]{
    return this.baseList
    .filter(list =>list.resumeClscode == resumeClscode)
    .map(data => {
      const select: SelectBox = {value: data.codeValue,viewValue:data.aname}
      return (select);
    });
  };

  /**
   * 再開種別と拠点に紐づく作業担当者リスト作成
   * @private
   * @param {string} resumeClscode
   * @param {string} baseCode
   * @return {SelectBox[]}
   * @memberof Sgke350dResultComponent
   */
  private createTntshList(baseCode: string,resumeClscode:string): SelectBox[] {
    return this.workTntshList
      .filter(list => (list.baseCode == baseCode) && (list.resumeClscode == resumeClscode))
      .map(data => {
        const select: SelectBox = { value: data.staffCode, viewValue: data.staffKanjiName };
        return (select);
      });
  };

  /**
   * セレクターリスト取得
   * @private
   * @param {any} list
   * @returns {SelectBox[]}
   * @memberof Sgke350dResultComponent
   */
  private getSelector(list: any): SelectBox[] {

    let selectBox: SelectBox[] = [];;

    list.map(data => {
      const select: SelectBox = { value: data.codeValue, viewValue: data.aname };
      selectBox.push(select);
    });

    return selectBox;
  }

}
